// signal-bus.js
import { reactive } from 'vue';

const state = reactive({
    slots: {},
    anySlots: [] // Slots, die auf alle Signale reagieren
});

const SignalBus = {
    emit(signal, payload) {
        // Aufrufen aller spezifischen Slots für das Signal
        if (state.slots[signal]) {
            Object.values(state.slots[signal]).forEach(slots => {
                slots.forEach(slot => {
                    slot(payload);
                });
            });
        }

        // Aufrufen aller globalen Slots
        state.anySlots.forEach(slot => slot(signal, payload));
    },
    connect(parent, signal, slot) {
        let uuid = parent.$.uid;

        if (!state.slots[signal]) {
            state.slots[signal] = {};
        }
        if (!state.slots[signal][uuid]) {
            state.slots[signal][uuid] = [];
        }
        state.slots[signal][uuid].push(slot);

        return () => {
            const index = state.slots[signal][uuid].indexOf(slot);
            if (index !== -1) {
                state.slots[signal][uuid].splice(index, 1);
                if (state.slots[signal][uuid].length === 0) {
                    delete state.slots[signal][uuid];
                    if (Object.keys(state.slots[signal]).length === 0) {
                        delete state.slots[signal];
                    }
                }
            }
        };
    },
    disconnectAllFromParent(parent) {
        let uuid = parent.$.uid;

        for (const signal in state.slots) {
            if (state.slots[signal][uuid]) {
                delete state.slots[signal][uuid];
                if (Object.keys(state.slots[signal]).length === 0) {
                    delete state.slots[signal];
                }
            }
        }
    },
    disconnect(signal) {
        delete state.slots[signal];
    },
    connectOnce(signal, slot) {
        state.slots[signal] = [slot];
    },
};

export default SignalBus;


// backup if somethink dos not work
/*
// signal-bus.js
import { reactive } from 'vue';

const state = reactive({
    slots: {}
});

const SignalBus = {
    emit(signal, payload) {

        if (state.slots[signal]) {
            state.slots[signal].forEach(slot => {


                slot(payload)}
            );
        }
    },
    connect(signal, slot) {
        if (!state.slots[signal]) {
            state.slots[signal] = [];
        }
        state.slots[signal].push(slot);
        return () => {  // Rückgabe einer Disconnect-Funktion zum Trennen des Slots
            const index = state.slots[signal].indexOf(slot);
            if (index !== -1) {
                state.slots[signal].splice(index, 1);
            }
        };
    },
};

export default SignalBus;
*/